"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from "react";
import { createBreakpoint } from "react-use";
import BrainContentPinnedWaves from "./BrainContentPinnedWaves";
import BrainContentInput from "./input/BrainContentInput";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { useLayout } from "../my-stream/layout/LayoutContext";
import useDeviceInfo from "@/hooks/useDeviceInfo";

// Create breakpoint hook with the same values as tailwind classes
// lg:tw-hidden is applied at min-width 1024px
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface BrainContentProps {
  readonly children: React.ReactNode;
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
  readonly showPinnedWaves?: boolean;
}
const BrainContent: React.FC<BrainContentProps> = t0 => {
  const $ = _c(20);
  const {
    children,
    activeDrop,
    onCancelReplyQuote,
    showPinnedWaves: t1
  } = t0;
  const showPinnedWaves = t1 === undefined ? true : t1;
  const {
    registerRef
  } = useLayout();
  const breakpoint = useBreakpoint();
  const {
    isApp
  } = useDeviceInfo();
  const pinnedElementRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== registerRef || $[1] !== showPinnedWaves) {
    t2 = () => {
      if (!showPinnedWaves) {
        registerRef("pinned", null);
      }
    };
    t3 = [showPinnedWaves, registerRef];
    $[0] = registerRef;
    $[1] = showPinnedWaves;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== registerRef || $[5] !== showPinnedWaves) {
    t4 = element => {
      pinnedElementRef.current = element;
      if (showPinnedWaves) {
        registerRef("pinned", element);
      }
    };
    $[4] = registerRef;
    $[5] = showPinnedWaves;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const setPinnedRef = t4;
  const shouldShowPinnedWaves = showPinnedWaves && breakpoint === "S" && isApp;
  let t5;
  if ($[7] !== setPinnedRef || $[8] !== shouldShowPinnedWaves || $[9] !== showPinnedWaves) {
    t5 = showPinnedWaves && <div ref={setPinnedRef} className="tw-sticky tw-top-0 tw-z-10 tw-bg-iron-950 tw-px-2 sm:tw-px-4 md:tw-px-6 lg:tw-px-0 lg:tw-hidden">{shouldShowPinnedWaves && <BrainContentPinnedWaves />}</div>;
    $[7] = setPinnedRef;
    $[8] = shouldShowPinnedWaves;
    $[9] = showPinnedWaves;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children) {
    t6 = <div className="tw-flex-1 tw-overflow-hidden"><div className="tw-h-full">{children}</div></div>;
    $[11] = children;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== activeDrop || $[14] !== onCancelReplyQuote) {
    t7 = activeDrop && <div className="tw-sticky tw-bottom-0 tw-z-[80] tw-bg-black tw-px-2 sm:tw-px-4 md:tw-px-6 lg:tw-px-0"><BrainContentInput activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} /></div>;
    $[13] = activeDrop;
    $[14] = onCancelReplyQuote;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className="tw-relative tw-flex tw-flex-col tw-h-full">{t5}{t6}{t7}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default BrainContent;